import { useMemo } from 'react';

import { Field } from '@kanda-libs/ks-component-ts';

import { Check } from 'lucide-react';

export interface DeclineOptionProps {
  active: boolean;
  onClick: () => void;
  id: string;
  text: string;
}

const DeclineOption: React.FunctionComponent<DeclineOptionProps> = function ({
  active,
  onClick,
  id,
  text,
}) {
  const className = useMemo(
    () =>
      [
        'text-left flex flex-row gap-x-3 px-4 py-3 rounded-xl border-2 transition-all flex text-14-22-b group',
        active
          ? 'bg-purple-50 border-purple-400'
          : 'bg-neutral-000 border-neutral-300 hover:border-purple-200',
      ].join(' '),
    [active],
  );

  const indicatorClassName = useMemo(
    () =>
      [
        'flex w-5 h-5 min-w-5 min-h-5 border-2 transition-all rounded-full mt-px mb-auto',
        active
          ? 'bg-purple-400 border-purple-400'
          : 'bg-neutral-000 border-neutral-700 group-hover:border-purple-400',
      ].join(' '),
    [active],
  );

  const label = useMemo(() => {
    if (id !== 'other') return text;
    return 'Another reason';
  }, [id, text]);

  return (
    <>
      <button type="button" id={id} onClick={onClick} className={className}>
        <div className={indicatorClassName}>
          <Check
            className="m-auto text-neutral-000"
            size={14}
            strokeWidth={3}
          />
        </div>
        <p>{label}</p>
      </button>
      {id === 'other' && active && (
        <Field.TextAreaInput
          type="textarea"
          name="reason"
          rows={5}
          placeholder="Please provide more details"
          className="!mb-0"
        />
      )}
    </>
  );
};

export default DeclineOption;
